import { Component, ComponentFactoryResolver } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { FileInfo } from 'src/app/shared/model/generic/fileInfo';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { BrowseComponent } from 'src/app/shared/components/browse/browse.component';
import { DataGridColumn } from 'src/app/shared/components/datagrid/datagrid-core.component';
import { ContratoBrowseFilterComponent } from './contrato-browse-filter.component';
import { ContratoDataService } from 'src/app/core/services/contrato-crud.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { ContratoSearchFilter } from 'src/app/model/contrato/contratoSearchFilter';
import { ContratoAnexo } from 'src/app/model/contrato/contratoAnexo';
import { Contrato } from 'src/app/model/contrato/contrato';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-contrato-browse',
    templateUrl: '../../../shared/components/browse/browse.component.html',
    standalone: false
})
export class ContratoBrowseComponent extends BrowseComponent<Contrato> {

  constructor(
    protected componentFactoryResolver: ComponentFactoryResolver,
    protected router: Router, protected route: ActivatedRoute,    protected modalService: NgbModal, 
    protected dataService: ContratoDataService, protected securityService: SecurityService) {

    super(componentFactoryResolver, router, route, modalService, dataService);

    this.title = 'Contratos';
    this.componentFilter = ContratoBrowseFilterComponent;
    this.uploadCallback = this.uploadAnexo;
    this.registoKmsCallback = this.registoKms;
    this.browseRouterLink = '/contratos';
    this.manageRouterLink = '/contratos';
    this.showAdd = false;
    this.canDelete = false;
    this.canDeleteHandler = false;
    this.showExportExcel = true;
    this.exportAnalysisLabel = 'Análise Revisões';
    this.exportAnalysisCallBack = this.getAnalise;
    this.showExportAnalysis = this.GetPermission(6007);

    this.filter = new ContratoSearchFilter();
    this.filter.pageNumber = 1;
    this.filter.pageSize = 10;
    this.filter.returnTotalCount = true;

    this.columns.push(
      new DataGridColumn(
        'numContrato', 'Nº Contrato', '[{"width": "100px","hyperLink": false}]'
      ));

    this.columns.push(
      new DataGridColumn(
        'matricula', 'Matrícula', '[{"width": "80px","hyperLink": false}]'
      ));

    this.columns.push(
      new DataGridColumn(
        'centroCusto', 'Centro Custo', '[{"width": "auto","hyperLink": false}]'
      ));

    this.columns.push(
      new DataGridColumn(
        'dataInicio', 'Data Iníco', '[{"width": "90px", "textAlign": "center", "formatDate": true }]'
      ));

    this.columns.push(
      new DataGridColumn(
        'dataFim', 'Data Fim', '[{"width": "90px", "textAlign": "center", "formatDate": true }]'
      ));

    this.columns.push(
      new DataGridColumn(
        'numKms', 'Kms', '[{"width": "70px", "textAlign": "right", "formatNumber": true }]'
      ));

    this.columns.push(
      new DataGridColumn(
        'numKmsConhecidos', 'Kms Atuais', '[{"width": "110px", "textAlign": "right", "formatNumber": true }]'
      ));

    this.columns.push(
      new DataGridColumn(
        'produto', 'Modelo', '[{"width": "auto" }]'
      ));

    this.columns.push(
      new DataGridColumn(
        '', '',
        '[{"width": "2%", "hyperLink": false, "singleButton": true, "buttonText": "upload", "buttonUpload": true }]'
      ));

    this.columns.push(
      new DataGridColumn(
        '', '',
        '[{"width": "2%", "hyperLink": false, "singleButton": true, "buttonText": "registoKms", "buttonRegistoKms": true }]'
      ));
  }

  public uploadAnexo = (id: number, descritivo: string, observacoes: string, file: FileInfo): void => {
    const anexo = new ContratoAnexo();
    anexo.contratoId = id;
    anexo.descritivo = descritivo;
    anexo.observacoes = observacoes;
    anexo.file = file;

    this.dataService
      .uploadAnexo(anexo)
      .subscribe((response: any) => {
        this.message = 'Ficheiro enviado com sucesso';
        this.popupDescription = '';
        this.popupRemarks = '';
        this.currentFile = null;
      },
        (error: any) => {
          console.log(error);
        });
  }

  public registoKms = (id: number, kms: number): Observable<any> => {
    return this.dataService.registoKms(id, kms);
  }

  public getAnalise = (filter: any): Observable<any> => {
    return this.dataService.SearchAnalise(filter);
  }

  private GetPermission = (lockId: number): boolean => {
    return this.securityService.canDisplay(lockId);
  }
}
